module.exports = __webpack_public_path__ + "static/media/credsee.7d343900.png";